import { RiWhatsappFill } from "react-icons/ri";
import { trackEvent } from "../../utils/analytics";

const handleWhatsAppClick = () => {
  trackEvent("contact_whatsapp");
  window.open("https://wa.me/919755010858", "_blank");
};

const ChatSection = () => {
  return (
    <div>
      <div className="fixed bottom-3 right-5 z-50 bg-[#25d366] w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110">
        <button
          type="button"
          title="Whatsapp at +919755010858"
          aria-label="WhatsApp"
          className="flex h-full w-full items-center justify-center rounded-full text-3xl text-white"
          onClick={handleWhatsAppClick}
        >
          <RiWhatsappFill />
        </button>
      </div>
    </div>
  );
};

export default ChatSection;
